import { CommonModule } from '@angular/common';
import {
  Component,
  EventEmitter,
  inject,
  Input,
  Output,
  ViewEncapsulation,
} from '@angular/core';
import { MatButton } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { TranslateModule, TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'mat-flat-button',
  templateUrl: './mat-flat-button.component.html',
  styleUrls: ['./mat-flat-button.component.scss'],
  standalone: true,
  encapsulation: ViewEncapsulation.None,
  imports: [MatButton, MatIconModule, CommonModule, TranslateModule],
})
export class MatFlatButtonComponent {
  translateService = inject(TranslateService);

  @Input() buttonId: string = '';

  @Input() buttonLabel: string = 'Button Label';

  @Input() buttonIconLeft: string = '';

  @Input() buttonIconRight: string = '';

  @Input() style = {};

  @Input() background: string = '#f1b90c';

  @Input() border: string = '';

  @Input() borderRadius: string = '';

  @Input() fontSize: string = '16';

  @Input() fontColor: string = '#090909';

  @Input() fontWeight: string = '400';

  @Input() width: string = '';

  @Input() minWidth: string = '';

  @Output() buttonClick: EventEmitter<void> = new EventEmitter<void>();

  onButtonClicked(): void {
    this.buttonClick.emit();
  }
}
